export default "__VITE_ASSET__OcVG0dw6__"